import { render, staticRenderFns } from "./vipInfo.vue?vue&type=template&id=42f794ce&scoped=true&"
import script from "./vipInfo.vue?vue&type=script&lang=js&"
export * from "./vipInfo.vue?vue&type=script&lang=js&"
import style0 from "./vipInfo.vue?vue&type=style&index=0&id=42f794ce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f794ce",
  null
  
)

export default component.exports